import React, { useEffect, useContext, useState } from "react";

import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
  IconButton,
  Switch,
} from "@material-ui/core";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import MaskService from "../../../utils/mask/maskService";
import { TitleTable } from "../../../components/basic/TitleTable";
import TextFieldCustom from "../../../components/basic/TextFieldCustom";
import SelectCustom from "../../../components/basic/SelectCustom";
import { GlobalVariables } from "../../../global";
import { UserContext } from "../../../context/UserContext";
import Btn from "../../../components/buttons/Btn";
import { getSegments } from "../../../repositories/segmentRepository";
import { CustomerContext } from "../contexts/CustomerContext";
import useCustomerController from "../controllers/CustomerController";
import { GridStyled, ImgStyled } from "../../../styles/GlobalStyle";
import { getCustomersPlug } from "../../../repositories/integrations/plug";
import { notify } from "../../../utils/notify";

export default function FormCustomer({ state }) {
  const { user } = useContext(UserContext);
  const {
    customerExists,
    setCustomerExists,
    documentType,
    setDocumentType,
    reason,
    setReason,
    fantasy,
    setFantasy,
    cep,
    setCep,
    uf,
    setUf,
    county,
    setCounty,
    address,
    setAddress,
    number,
    setNumber,
    district,
    setDistrict,
    telephone,
    setTelephone,
    cnpj,
    setCnpj,
    cnpjMatriz,
    setCnpjMatriz,
    ie,
    setIe,
    im,
    setIm,
    complement,
    setComplement,
    email,
    setEmail,
    segment,
    setSegment,
    listSegments,
    setListSegments,
    checkMatriz,
    setCheckMatriz,
    checkAccountant,
    setCheckAccountant,
    listAccountants,
    setListAccountants,
    accountantCustomer,
    setAccountantCustomer,
    hasCertificate,
    setHasCertificate,
    passwordCertificate,
    setPasswordCertificate,

    logomarca,
    setLogomarca,
    errors,
    loadings,
    setLoadings,
  } = useContext(CustomerContext);
  const {
    handleChangeCep,
    handleSaveCustomer,
    handleChangeCnpjCpf,
    handleChangeDocumentType,
    handleBirthDate,
  } = useCustomerController();
  const [showPasswordCertific, setShowPasswordCertific] = useState(false);
  const [birthDateToState, setBirthDateToState] = useState();

  useEffect(() => {
    (async () => {
      try {
        setLoadings((current) => ({ ...current, screen: true }));

        if (!state?.CNPJ) {
          setCustomerExists(false);
          return;
        }

        const cnpjLength = state?.CNPJ.replace(/[^0-9]+/g, "").length;

        setDocumentType(cnpjLength > 11 ? "cnpj" : "cpf");

        setCustomerExists(true);

        setCnpj(
          MaskService.toMask(
            cnpjLength > 11 ? "cnpj" : "cpf",
            state?.CNPJ || ""
          )
        );

        const { data } = await getCustomersPlug({
          params: `/${state?.CNPJ.replace(/[^0-9]+/g, "")}?downloads=Logomarca`,
        });

        if (!data?.data)
          return notify("Não foi possível encontrar dados de cliente");

        setIe(data.data.IE || "");
        setIm(data.data.IM || "");
        setFantasy(data.data.Fantasia || "");
        setReason(data.data.Razao || "");
        setCep(MaskService.toMask("cep", data.data.CEP || ""));
        setCounty(data.data.Municipio || "");
        setUf(data.data.UF || "");
        setAddress(data.data.Endereco || "");
        setNumber(data.data.Numero || "");
        setDistrict(data.data.Bairro || "");
        setComplement(data.data.Complemento || "");
        setTelephone(MaskService.toMask("cel-phone", data.data.Telefone || ""));
        setEmail(data.data.Email || "");
        setCnpjMatriz(MaskService.toMask("cnpj", data.data.MatrizCNPJ || ""));
        setCheckAccountant(data.data.FlagContador);
        setCheckMatriz(!!data.data.MatrizCNPJ);
        setHasCertificate(!!data.data.CaminhoCertificado);
        setPasswordCertificate(data.data.SenhaCertificado || "");
        setLogomarca(data.data.Logomarca || "");
      } catch (error) {
        console.error(error);
      } finally {
        setLoadings((current) => ({ ...current, screen: false }));
      }
    })();
  }, [
    state,
    setCheckMatriz,
    setAddress,
    setCep,
    setCnpj,
    setCnpjMatriz,
    setComplement,
    setCounty,
    setCustomerExists,
    setDistrict,
    setDocumentType,
    setEmail,
    setFantasy,
    setIe,
    setIm,
    setLoadings,
    setNumber,
    setReason,
    setTelephone,
    setUf,
    setHasCertificate,
    setLogomarca,
    setPasswordCertificate,
    setCheckAccountant,
    setSegment,
    listSegments,
  ]);

  useEffect(() => {
    (async () => {
      try {
        setLoadings((current) => ({ ...current, segments: true }));

        const { data: segments } = await getSegments();

        if (Array.isArray(segments?.data)) setListSegments(segments.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadings((current) => ({ ...current, segments: false }));
      }
    })();
  }, [setLoadings, setListSegments]);

  useEffect(() => {
    if (!listSegments.length) return;

    if (!state?.IdSegmento) {
      setSegment(
        listSegments.find((s) => s.Id === GlobalVariables.SEGMENTS.DEFAULT)
      );
      return;
    }

    setSegment(listSegments.find((s) => s.Id === state?.IdSegmento));
  }, [listSegments, state, setSegment]);

  useEffect(() => {
    (async () => {
      const { data: respCustomes } = await getCustomersPlug({
        params: "?FlagContador=true",
      });

      if (respCustomes?.success && Array.isArray(respCustomes?.data)) {
        setListAccountants(respCustomes?.data);
      }
    })();
  }, [setListAccountants]);

  useEffect(() => {
    if (!listAccountants.length || !state?.ContadorCNPJ) return;

    setAccountantCustomer(
      listAccountants.find((a) => a.CNPJ === state?.ContadorCNPJ) || null
    );
  }, [listAccountants, setAccountantCustomer, state]);

  return (
    <>
      <Grid item xs={12}>
        <TitleTable title="Cliente" />
      </Grid>

      <Grid item xs={12}>
        <RadioGroup value={documentType} onChange={handleChangeDocumentType}>
          <Grid container>
            <FormControlLabel
              disabled={customerExists}
              value="cnpj"
              checked={documentType === "cnpj"}
              control={<Radio color="primary" />}
              label="CNPJ"
            />
            <FormControlLabel
              disabled={customerExists}
              value="cpf"
              checked={documentType === "cpf"}
              control={<Radio color="primary" />}
              label="CPF"
            />
          </Grid>
        </RadioGroup>
      </Grid>

      <Grid item container spacing={2} alignItems="center">
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            disabled={customerExists}
            label={`${documentType.toUpperCase()}*`}
            autoFocus
            type="text"
            value={cnpj}
            onChange={handleChangeCnpjCpf}
            error={errors.cnpj}
            mask={documentType}
          />
        </Grid>

        {!customerExists && documentType === "cpf" && (
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              disabled={customerExists}
              label="Data de nascimento*"
              type="date"
              onChange={(e) => setBirthDateToState(e.target.valueAsDate)}
              onBlur={() => handleBirthDate(birthDateToState)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={50}
            label="IE"
            type="text"
            value={ie}
            setValue={setIe}
            error={errors.ie}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={50}
            label="IM"
            type="text"
            value={im}
            setValue={setIm}
            error={errors.im}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <SelectCustom
            loading={!!loadings.segments}
            label="Segmento"
            keyObject="Descricao"
            value={segment}
            setValue={setSegment}
            error={errors.segment}
            optionsList={listSegments}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={120}
            label="Fantasia*"
            type="text"
            value={fantasy}
            setValue={setFantasy}
            error={errors.fantasy}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={120}
            label="Razão*"
            type="text"
            value={reason}
            setValue={setReason}
            error={errors.reason}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            mask="cep"
            label="CEP*"
            type="text"
            value={cep}
            onChange={handleChangeCep}
            error={errors.cep}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={50}
            label="Município*"
            type="text"
            value={county}
            setValue={setCounty}
            error={errors.county}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            label="UF*"
            type="text"
            value={uf}
            onChange={(e) => {
              if (e.target.value.length < 3) {
                setUf(e.target.value.toString().toUpperCase());
              }
            }}
            error={errors.uf}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={50}
            label="Endereço*"
            type="text"
            value={address}
            setValue={setAddress}
            error={errors.address}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            label="Número"
            type="number"
            value={number.replace(/[^0-9]+/g, "")}
            onChange={(e) =>
              setNumber(e.target.value.replace(/[^0-9]+/g, "").substring(0, 50))
            }
            error={errors.number}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={50}
            label="Bairro*"
            type="text"
            value={district}
            setValue={setDistrict}
            error={errors.district}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            maxLength={50}
            label="Complemento"
            type="text"
            value={complement}
            setValue={setComplement}
            error={errors.complement}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            label="Telefone*"
            type="text"
            mask="cel-phone"
            value={telephone}
            setValue={setTelephone}
            error={errors.telephone}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <TextFieldCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="E-mail master*"
            type="text"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value.toLowerCase().substring(0, 50))
            }
            error={errors.email}
          />
        </Grid>

        <Grid item lg={3} md={3} sm={6} xs={12}>
          <SelectCustom
            loading={!!loadings.promoters}
            label="Escritório Responsável"
            keyObject="Fantasia"
            value={accountantCustomer}
            setValue={setAccountantCustomer}
            error={errors.accountantCustomer}
            optionsList={listAccountants}
          />
        </Grid>

        <Grid item flex={1}>
          <FormControlLabel
            control={
              <Switch
                checked={checkAccountant}
                onChange={() => setCheckAccountant((current) => !current)}
                color="primary"
                name="É Escritório Contábil"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            }
            label="É Escritório Contábil"
          />
        </Grid>

        <Grid item flex={1}>
          <FormControlLabel
            control={
              <Switch
                checked={checkMatriz}
                onChange={() => {
                  setCnpjMatriz("");
                  setCheckMatriz((current) => !current);
                }}
                color="primary"
                name="Vincular matriz"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            }
            label="Vincular matriz"
          />
        </Grid>

        {checkMatriz && (
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              label="CNPJ Matriz*"
              type="text"
              value={MaskService.toMask("cnpj", cnpjMatriz)}
              mask="cnpj"
              setValue={setCnpjMatriz}
              error={errors.cnpjMatriz}
            />
          </Grid>
        )}
        <Grid item flex={1}></Grid>

        {hasCertificate && (
          <>
            <Grid item flex={1}>
              <Tooltip title="Possui um certificado cadastrado">
                <AttachFileOutlinedIcon />
              </Tooltip>
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldCustom
                disabled
                label="Senha do Certificado*"
                value={passwordCertificate}
                mask="cnpj"
                onChange={() => {}}
                type={showPasswordCertific ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() =>
                        setShowPasswordCertific(!showPasswordCertific)
                      }
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {showPasswordCertific ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  ),
                }}
              />
            </Grid>
          </>
        )}

        {!!logomarca && (
          <ImgStyled
            src={`data:image/jpeg;base64,${logomarca}`}
            max-width="80px"
            max-height="80px"
          />
        )}

        <GridStyled margin="15px 0 0 0" item container justify="center">
          <Btn label="Salvar Cliente" onClick={handleSaveCustomer} />
        </GridStyled>
      </Grid>
    </>
  );
}
